import { LocalStorageRegistry } from '@/constants/localStorageRegistry'

/**
 * Checks if the user manually modified their location radius
 * This information is stored on the local storage whenever the user manually updates their radius search
 */
export const didUserModifyRadius = (): boolean => {
  /** Checks on local storage if the user have manually modified  their radius */
  const modified = window.localStorage.getItem(LocalStorageRegistry.USER_ADJUSTED_RADIUS)

  return modified === 'true'
}
